import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';

const skippedURLs = [
	"auth/login",
	"2fa/status",
	"2fa/verify",
	"2fa/setup",
	"2fa/challenge",
];

// Function to check if the request URL contains any of the skipped URLs
function shouldSkip(requestURL: string) {
	// Check if any skipped URL is a substring of the request URL
	return skippedURLs.some(skipURL => requestURL.includes(skipURL));
}


export const authInterceptor: HttpInterceptorFn = (req, next) => {
	if (shouldSkip(req.url)) {
		return next(req);
	}

	// If Authorization is already set explicitly (e.g. addToCart), don't override it
	if (req.headers.has('Authorization')) {
		return next(req);
	}

	const loggedInStaff = inject(AuthService).getLoggedInStaff();
	const authToken = loggedInStaff?.token ?? "";

	const clonedReq = req.clone({
		setHeaders: {
			Authorization: `Bearer ${authToken}`,
		}
	});
	return next(clonedReq);
};
